import React from "react";
import styled from "@emotion/styled";
import Loader from "views/universal/Loader/Loader";
import { Col, Row, Badge } from "react-bootstrap";
import { centimesToCurrency } from "utils/utils";
import Vigilance from "./Options/Vigilance";
import ToDelete from "./Options/ToDelete";
import HidePhoneOnDistribution from "./Options/HidePhoneOnDistribution";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWallet,
  faShoppingBag,
  faSmile,
  faLifeRing,
  faCreditCard
} from "@fortawesome/free-solid-svg-icons";

const Customer = (props) => {
  const {
    customer,
    establishment,
    openPopupCustomerHandle,
    sendSMSHandle,
    onOpenPasswordReset,
    onOpenOrders,
    onOpenPool,
    onOpenAdvantage,
    onOpenSav,
    onOpenTransactions,
    inProgressSavCount = 0,
  } = props;


  return (
    <>
      {customer && customer.isLoading ? (
        <Loader items={1} />
      ) : (
        customer.id && (
          <>
            <Info noGutters>
              <Col xs={12} sm={6} className="vAlign">
                <small>Nom prénom - Id {customer.id}</small>
                <Title>{customer.lastname + " " + customer.firstname}</Title>
                {customer?.companion_price && 
                  <Title>Abonnée Compagnon ({centimesToCurrency(customer?.companion_price || 0)})</Title>
                }
                <Coordonate>
                  {customer.email}
                  <br />
                  {customer.phone}
                  <br />
                  Code parrainage : {customer.sponsor_code}
                  {customer.paygreen_buyer_id && (
                    <>
                      <br />
                      <PaygreenLink
                        href={`https://app.paygreen.fr/buyers/${customer.paygreen_buyer_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Voir le profil Paygreen
                      </PaygreenLink>
                    </>
                  )}
                  {process.env.REACT_APP_ENV !== "prod" && customer.paygreen_buyer_id_sandbox && (
                    <>
                      <br />
                      <PaygreenLink
                        href={`https://sb-app.paygreen.fr/buyers/${customer.paygreen_buyer_id_sandbox}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Voir le profil Paygreen sandbox
                      </PaygreenLink>
                    </>
                  )}
                  {!customer.paygreen_buyer_id && (process.env.REACT_APP_ENV === "prod" || !customer.paygreen_buyer_id_sandbox) && (
                    <>
                      <br />
                      <PaygreenNoProfile>Pas de profil Paygreen</PaygreenNoProfile>
                    </>
                  )}
                </Coordonate>
                <ButtonBtsp
                  onClick={(e) => onOpenTransactions(customer, e)}
                  disabled={customer.isLoading}
                  variant="outline-light"
                  className="mb-2"
                >
                  <FontAwesomeIcon icon={faCreditCard} /> Voir ses transactions bancaires
                </ButtonBtsp>
                <ButtonBtsp
                  onClick={() => openPopupCustomerHandle(customer)}
                  disabled={customer.isLoading}
                  variant="outline-light"
                >
                  Modifier ce client
                </ButtonBtsp>
              </Col>
              <Col xs={12} sm={6} className="vAlign">
                <small>Code de connexion boutique kiosque</small>
                <Coordonate>{customer.code_id}</Coordonate>
                 
                  <ButtonBtsp
                    onClick={() => {
                      if (
                        window.confirm(
                          "Êtes-vous sûr de vouloir envoyer le code de connexion par SMS ?"
                        )
                      ) {
                        sendSMSHandle(customer);
                      }
                    }}
                    disabled={customer.isLoading}
                    variant="outline-light"
                  >
                    Envoyer son code de connexion par SMS
                  </ButtonBtsp>
                  <ButtonBtsp
                    onClick={() => onOpenPasswordReset(customer)}
                    disabled={customer.isLoading}
                    variant="outline-light"
                    className="mt-2"
                  >
                    Lien de nouveau mot de passe
                  </ButtonBtsp>
                
              </Col>

            </Info>
            
            <Row className="mt-3">
              <Col xs={12} sm={4}>
                <div className="d-grid gap-2">
                  <ButtonBtsp
                    variant="dark"
                    size="lg"
                    full
                    onClick={(e) => onOpenOrders(customer, e)}
                  >
                    <FontAwesomeIcon icon={faShoppingBag} /> Voir ses commandes
                  </ButtonBtsp>
                </div>
              </Col>
              <Col xs={12} sm={4}>
                <ButtonBtsp
                  size="lg"
                  onClick={(e) => onOpenPool(customer.id, e)}
                  variant="info"
                  full
                >
                  <FontAwesomeIcon icon={faWallet} /> Voir son porte-monnaie
                </ButtonBtsp>
              </Col>
              <Col xs={12} sm={4}>
                <ButtonBtsp
                  onClick={(e) => onOpenAdvantage(customer.id, e)}
                  variant="success"
                  size="lg"
                  full
                >
                  <FontAwesomeIcon icon={faSmile} /> Voir ses avantages
                </ButtonBtsp>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col xs={12}>
                <ButtonBtsp
                  onClick={(e) => onOpenSav(customer, e)}
                  variant="warning"
                  size="lg"
                  full
                >
                  <FontAwesomeIcon icon={faLifeRing} /> Faire un SAV
                  {inProgressSavCount > 0 && (
                    <>
                      {" "}
                      <Badge variant="light" title="Propositions en attente de réponse du client : détail dans la fenêtre">
                        {inProgressSavCount > 1 ? `${inProgressSavCount} propositions en cours` : "1 proposition en cours"}
                      </Badge>
                    </>
                  )}
                </ButtonBtsp>
              </Col>
            </Row>

            <Options>
              <h4>Options :</h4>
              <HidePhoneOnDistribution customer={customer} establishment={establishment}/>
              <br /><br />
              <ToDelete customer={customer} establishment={establishment}/>
              <br /><br />
              <Vigilance customer={customer} />
              <br />
              {/* On ne l'utilise plus au date de 03/10/24 car le panneau SAV fait la meme chose de facon centraliser */}
              {/* <LastOrderAmountOffer
                customer={customer} establishment={establishment}
              /> */}
            </Options>

          </>
        )
      )}

    </>
  );
};

const Info = styled(Row)`
  background: linear-gradient(130deg, rgb(66, 152, 83), rgb(144, 163, 69));
  padding: 1.5rem 1rem;
  border-radius: 4px;
`;

const Title = styled.h2`
  color: ${(props) => props.theme.colors.white};
  margin-bottom: 0rem;
`;

const Options = styled.div`
  color: ${(props) => props.theme.colors.black};
  background-color: white;
  margin: 1rem 0;
  padding: 1rem 1rem;
  border-radius: 4px;
  border: solid 1px #ddd;
`;

const Coordonate = styled.h3`
  color: ${(props) => props.theme.colors.white};
  font-style: italic;
  font-size: 1.4rem;
`;

const PaygreenLink = styled.a`
  color: ${(props) => props.theme.colors.white};
  text-decoration: underline;
  font-size: 1.2rem;
  &:hover {
    color: ${(props) => props.theme.colors.white};
    opacity: 0.9;
  }
`;

const PaygreenNoProfile = styled.span`
  color: ${(props) => props.theme.colors.white};
  font-size: 1.2rem;
  font-style: italic;
  opacity: 0.9;
`;

const ButtonBtsp = styled(Button)`
  display: ${(props) => props.full ? 'block' : 'inline-block'};
  width: ${(props) => props.full ? '100%' : 'fit-content'};
  
`;

Customer.propTypes = {};

Customer.defaultProps = {};

export default Customer;
